import { PageEdit } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconPageEdit12Line = createIcon(PageEdit, 12, "Line");
export const IconPageEdit16Line = createIcon(PageEdit, 16, "Line");
export const IconPageEdit20Line = createIcon(PageEdit, 20, "Line");
export const IconPageEdit24Line = createIcon(PageEdit, 24, "Line");
export const IconPageEdit32Line = createIcon(PageEdit, 32, "Line");
export const IconPageEdit48Line = createIcon(PageEdit, 48, "Line");
export const IconPageEdit64Line = createIcon(PageEdit, 64, "Line");
